import { Dialog } from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';

interface DeleteConfirmDialogProps {
    /** Whether the dialog is open. */
    open: boolean;
    /** Callback when dialog is closed. */
    onClose: () => void;
    /** Callback when delete is confirmed. */
    onConfirm: () => void;
    /** Title for the dialog. */
    title: string;
    /** Description/warning message. */
    description: string;
    /** Label for the confirm button. */
    confirmLabel?: string;
    /** Whether the delete action is in progress. */
    isLoading?: boolean;
}

/**
 * Reusable confirmation dialog for delete actions.
 * Shows a warning message and requires explicit confirmation.
 */
export function DeleteConfirmDialog({
    open,
    onClose,
    onConfirm,
    title,
    description,
    confirmLabel = 'Delete',
    isLoading = false,
}: DeleteConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} title={title} size="sm">
            <div className="space-y-4">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    {description}
                </p>

                <div className="flex justify-end gap-3">
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}
